import { AppRoutes } from '../../../Core/App/AppRoutes';
import { AppRouteType } from '../../Components/Templates/AppRouter/AppRouteType';
import { PrivateRoute } from '../../Components/Templates/AppRouter/PrivateRoute';
import { LoadableListPointagePage } from '../../Pages/Pointages/ListPointage/LoadableListPointagePage';

export const getListPointageRoute = (props: object): AppRouteType => ({
    id: AppRoutes.POINTAGES_LIST,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.POINTAGES_LIST,
        component: LoadableListPointagePage,
        ...props,
    },
});

export const getPointageRoutes = (args: object) => [
    getListPointageRoute(args),
];
